// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__5jDL9","alert":"SettungsInbox_alert__2D5Qh"};